/* Mats · Productos de colección
   Solo la barra de progreso de los modos carrusel.
   La tarjeta (guardar, +, añadir) vive en mats-product-card.js
   y el quick view en mats-quick-view.js. */
(() => {
  if (customElements.get('mats-collection-products')) return;

  const INSET = 3;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class MatsCollectionProducts extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-mpg-track]');
      this.bar = this.querySelector('[data-mpg-bar]');
      this.thumb = this.querySelector('[data-mpg-thumb]');
      if (!this.track || !this.bar) return;

      this._raf = 0;
      this._onScroll = () => {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => { this._raf = 0; this.update(); });
      };
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      this._ro = new ResizeObserver(() => this.update());
      this._ro.observe(this.track);
      this._onPointerDown = this.onPointerDown.bind(this);
      this.bar.addEventListener('pointerdown', this._onPointerDown);
      this.update();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this._onScroll);
      this.bar?.removeEventListener('pointerdown', this._onPointerDown);
      this._ro?.disconnect();
      cancelAnimationFrame(this._raf);
    }

    get maxScroll() {
      return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }

    metrics() {
      const barW = this.bar.clientWidth - INSET * 2;
      const thumbW = Math.max(40, Math.round(barW * (this.track.clientWidth / this.track.scrollWidth)));
      return { thumbW, room: Math.max(1, barW - thumbW) };
    }

    update() {
      const max = this.maxScroll;
      const scrollable = max > 2 && getComputedStyle(this.track).display === 'flex';
      this.bar.hidden = !scrollable;
      if (!scrollable) return;
      const { thumbW, room } = this.metrics();
      const progress = Math.min(1, Math.max(0, this.track.scrollLeft / max));
      this.thumb.style.setProperty('--mpg-thumb-w', `${thumbW}px`);
      this.thumb.style.setProperty('--mpg-thumb-x', `${progress * room}px`);
    }

    onPointerDown(e) {
      if (e.button !== 0) return;
      e.preventDefault();
      const { thumbW, room } = this.metrics();
      const max = this.maxScroll;
      const factor = max / room;
      if (e.target !== this.thumb) {
        const x = e.clientX - this.bar.getBoundingClientRect().left - INSET - thumbW / 2;
        this.track.scrollLeft = Math.min(max, Math.max(0, x * factor));
      }
      const startX = e.clientX;
      const startScroll = this.track.scrollLeft;
      this.classList.add('is-dragging');
      this.bar.setPointerCapture(e.pointerId);
      const move = (ev) => { this.track.scrollLeft = startScroll + (ev.clientX - startX) * factor; };
      const up = () => {
        this.bar.removeEventListener('pointermove', move);
        this.bar.removeEventListener('pointerup', up);
        this.bar.removeEventListener('pointercancel', up);
        this.classList.remove('is-dragging');
        this.snapToNearest();
      };
      this.bar.addEventListener('pointermove', move);
      this.bar.addEventListener('pointerup', up);
      this.bar.addEventListener('pointercancel', up);
    }

    snapToNearest() {
      const cells = [...this.track.children];
      if (!cells.length) return;
      const pad = parseFloat(getComputedStyle(this.track).scrollPaddingInlineStart) || 0;
      const base = this.track.getBoundingClientRect().left + pad;
      let best = cells[0];
      let bestD = Infinity;
      cells.forEach((c) => {
        const d = Math.abs(c.getBoundingClientRect().left - base);
        if (d < bestD) { bestD = d; best = c; }
      });
      this.track.scrollTo({
        left: Math.min(this.maxScroll, Math.max(0, this.track.scrollLeft + best.getBoundingClientRect().left - base)),
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
      });
    }
  }

  customElements.define('mats-collection-products', MatsCollectionProducts);
})();
